import type { Node as ProsemirrorNode } from "prosemirror-model";

import React from "react";

import { AssetToken } from "@agent-ui/features/chat/components/chat-elements/chat-tokens/AssetToken";
import { createRoot } from "react-dom/client";

/**
 * Custom NodeView for asset tokens.
 * NOTE (Kevin, 2025-12-18): Uses createRoot instead of ReactNodeViewRenderer
 * to fix an issue where asset tokens weren't rendered correctly by Tiptap's
 * contentComponent mechanism.
 */
export function AssetTokenNode({ node }: { node: ProsemirrorNode }) {
  const dom = document.createElement("span");
  dom.className = "asset-component";
  dom.contentEditable = "false";
  dom.style.display = "inline";

  const data = node.attrs.data;
  if (data && data.name) {
    const root = createRoot(dom);
    root.render(React.createElement(AssetToken, { data }));

    return {
      dom,
      destroy: () => {
        root.unmount();
      },
    };
  }

  return { dom };
}
